import(/* webpackMode: "eager" */ "/app/app/forgot-password/page.tsx");
